import { Spin } from 'antd';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { initGoogleAnalytics } from './analytics/googleAnalytics';
import { App } from './App';
import { loadRuntimeConfig } from './config/runtimeConfig';
import './theme/global.css';
import './i18n';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in index.html');

const root = createRoot(rootEl);

// While runtime config loads, show a minimal spinner — keeps the FE fully runtime-configured
// (the same bundle ships to every environment).
root.render(
  <div
    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}
  >
    <Spin size="large" />
  </div>,
);

loadRuntimeConfig()
  .then((config) => {
    // After config, before render: the id is per-environment and only known at
    // runtime. No id configured (localhost, Dev) means no tag is injected.
    initGoogleAnalytics(config.analytics?.measurementId);
    root.render(
      <StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </StrictMode>,
    );
  })
  .catch((err: unknown) => {
    console.error('Failed to bootstrap front-end:', err);
    root.render(
      <div style={{ padding: 24 }}>
        <h1>Failed to load application</h1>
        <p>{err instanceof Error ? err.message : 'Unknown error'}</p>
      </div>,
    );
  });
